import * as React from 'react';
import { mergeEventHandlers, useControlledState } from '../../utils/index.js';
import { Menu } from '../Menu/Menu.js';
import { FloatingTree } from '@floating-ui/react';
export const DropdownMenu = React.forwardRef((props, forwardedRef) =>
  React.createElement(
    FloatingTree,
    null,
    React.createElement(DropdownMenuContent, {
      ref: forwardedRef,
      ...props,
    }),
  ),
);
DropdownMenu.displayName = 'DropdownMenu';
let DropdownMenuContent = React.forwardRef((props, forwardedRef) => {
  let {
    menuItems,
    children,
    role = 'menu',
    visible: visibleProp,
    placement = 'bottom-start',
    matchWidth = false,
    onVisibleChange,
    portal = true,
    middleware,
    ...rest
  } = props;
  let [visible, setVisible] = useControlledState(
    false,
    visibleProp,
    onVisibleChange,
  );
  let menuContent = React.useMemo(() => {
    if ('function' == typeof menuItems)
      return menuItems(() => setVisible(false));
    return menuItems;
  }, [menuItems, setVisible]);
  return React.createElement(
    Menu,
    {
      trigger: children,
      onKeyDown: mergeEventHandlers(props.onKeyDown, (e) => {
        if (e.defaultPrevented) return;
        if ('Tab' === e.key) setVisible(false);
      }),
      role: role,
      ref: forwardedRef,
      portal: portal,
      popoverProps: React.useMemo(
        () => ({
          placement,
          matchWidth,
          visible,
          onVisibleChange: setVisible,
          middleware,
        }),
        [matchWidth, middleware, placement, setVisible, visible],
      ),
      ...rest,
    },
    menuContent,
  );
});
